"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastUpdateLayout = void 0;
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
/** @internal */
exports.LastUpdateLayout = (0, buffer_layout_1.struct)([(0, util_1.u64)('slot'), (0, util_1.bool)('stale')], 'lastUpdate');
